module.exports = __webpack_public_path__ + "img/chrome_2021-10-03_14-54-28.5a5d2826.png";